<template>
  <!-- Container (access Section) -->
  <div class="w3-content w3-container w3-padding-64" id="access">
    <h3 class="w3-center">ACCESS</h3>
    <p class="w3-center">
      <em
        >{{ subtitle }}</em
      >
    </p>
    <br />
    <FromNearbyStations />
    <FromAirports />
    <!--      <FromAirports />-->
  </div>
</template>
<script>
import { ref, computed } from "vue";
import { language_util } from "@/classes/language/language_util.js";
import { access } from "@/classes/access/access.js";
import FromNearbyStations from "@/views/access/FromNearbyStations.vue"
import FromAirports from "@/views/access/FromAirports.vue"
export default {
  components: {
    FromNearbyStations,
    FromAirports
  },
  setup() {
    const subtitle = computed(() =>
      access.get_subtitle(language.value)
    );
    const language = computed(() => {
      return language_util.get_language();
    });

    return {
      subtitle
    }

  }
};
</script>

<style>
.active {
  color: red;
}
</style>